import type { Fields } from '@lumapps/utils/types/Fields';

import type { SearchInstancesParams } from './api/types';
import type { Instance } from './types';

export const SIDE_NAV_ID = 'instances';

/**
 * Instance to be used as the default one when creating a new one.
 */
export const DEFAULT_INSTANCE: Instance = {
    defaultLang: '',
    id: '',
    isDefaultInstance: false,
    logo: [],
    name: '',
    slug: '',
    title: {},
    uid: '',
};

export enum INSTANCE_PERMISSIONS {
    INSTANCE_EDIT = 'INSTANCE_EDIT',
}

export const MINIMAL_INSTANCE_FIELDS_ARRAY: Fields<Instance> = ['id', 'uid', 'slug', 'name', 'subtitle', 'logo'];
export const MINIMAL_INSTANCE_FIELDS = MINIMAL_INSTANCE_FIELDS_ARRAY.join(',');

export const SEARCH_INSTANCE_DEFAULT_PARAMS: SearchInstancesParams = {
    maxResults: 10,
    sortOrder: 'name',
    userFavoritesOnly: true,
    itemFields: MINIMAL_INSTANCE_FIELDS,
};
